// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fiisr","icon":"styles_icon__26anv"};